var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menubutton"},[_c('button',{class:_vm.buttonClass,on:{"click":function($event){return _vm.toggleMenu()}}},[(_vm.buttonIcon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.buttonIcon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.buttonLabel))]),(_vm.visible)?_c('div',{staticClass:"menu"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }